module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/introduces/03-a80a271a2a4aa4bf8a42616d67e2a4ba.jpg";